import { render, staticRenderFns } from "./AddGuardian.vue?vue&type=template&id=ffa525b2&scoped=true"
import script from "./AddGuardian.vue?vue&type=script&lang=js"
export * from "./AddGuardian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa525b2",
  null
  
)

export default component.exports